import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: "#fff",
    borderTop: "2px solid #4241418c",
    borderBottom: "1px solid #e6e6e6",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    padding: "5px 20px",
  },
  avtar: {
    width: "42px !important",
    height: "42px !important",
    borderRadius: "5px !important",
    backgroundColor: "#e5e8eb !important",
    color: "#1b232c !important",
    fontWeight: "700 !important",
    fontSize: "16px !important",
    transition: "all 0.2s ease !important",
  },
  status: {
    marginLeft: "1px !important",
    backgroundColor: "#e8f5e9 !important",
    color: "#2e7d32 !important",
    fontWeight: "600 !important",
  },
  headerText: { fontSize: "14px !important", color: "#6f7782 !important" },
  headerDescription: {
    fontSize: "14px !important",
    color: "#6f7782 !important",
  },
}));
